import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { formatCurrency } from '../../../../services/oathAgencyVitalsService';

// Accounts Receivable Table Component - entire rows are clickable
const AccountsReceivableTable = ({ data, onRowClick }) => {
  if (!data || data.length === 0) {
    return (
      <div className="p-4 qhd:p-5 4k:p-6 text-center text-gray-500 dark:text-gray-400 text-sm qhd:text-base 4k:text-lg">
        No accounts receivable data available
      </div>
    );
  }

  // Separate totals row from data rows
  const dataRows = data.filter(row => row.description !== 'Total');
  const totalRow = data.find(row => row.description === 'Total');

  const handleRowClick = (row) => {
    if (onRowClick) {
      onRowClick('accounts-receivable', row.description);
    }
  };

  return (
    <div className="p-3 qhd:p-4 4k:p-5 overflow-x-auto">
      <table className="w-full text-xs qhd:text-sm 4k:text-base">
        <thead>
          <tr className="border-b border-gray-200 dark:border-gray-700">
            <th className="text-left font-medium text-gray-500 dark:text-gray-400 pb-1.5 qhd:pb-2 4k:pb-2.5"></th>
            <th className="text-right font-medium text-gray-500 dark:text-gray-400 pb-1.5 qhd:pb-2 4k:pb-2.5">Net</th>
            <th className="text-right font-medium text-gray-500 dark:text-gray-400 pb-1.5 qhd:pb-2 4k:pb-2.5">Misc</th>
            <th className="text-right font-medium text-gray-500 dark:text-gray-400 pb-1.5 qhd:pb-2 4k:pb-2.5">BUF</th>
            {onRowClick && <th className="w-4 qhd:w-5 4k:w-6"></th>}
          </tr>
        </thead>
        <tbody className="text-gray-700 dark:text-gray-300">
          {dataRows.map((row, index) => (
            <tr
              key={row.description}
              className={`${index < dataRows.length - 1 ? 'border-b border-gray-100 dark:border-gray-700' : 'border-b border-gray-200 dark:border-gray-600'} ${
                onRowClick ? 'cursor-pointer hover:bg-primary/5 dark:hover:bg-primary/10 transition-all group' : ''
              }`}
              onClick={onRowClick ? () => handleRowClick(row) : undefined}
              role={onRowClick ? 'button' : undefined}
              tabIndex={onRowClick ? 0 : undefined}
              onKeyDown={onRowClick ? (e) => e.key === 'Enter' && handleRowClick(row) : undefined}
            >
              <td className={`py-1.5 qhd:py-2 4k:py-2.5 ${onRowClick ? 'group-hover:text-primary dark:group-hover:text-primary-light' : ''}`}>{row.description}</td>
              <td className="py-1.5 qhd:py-2 4k:py-2.5 text-right">{row.netDisplay || formatCurrency(row.net)}</td>
              <td className="py-1.5 qhd:py-2 4k:py-2.5 text-right">{row.miscDisplay || formatCurrency(row.misc)}</td>
              <td className="py-1.5 qhd:py-2 4k:py-2.5 text-right">{row.bufDisplay || formatCurrency(row.buf)}</td>
              {onRowClick && (
                <td className="py-1.5 qhd:py-2 4k:py-2.5 w-4 qhd:w-5 4k:w-6">
                  <ChevronRightIcon className="w-3.5 h-3.5 qhd:w-4 qhd:h-4 4k:w-5 4k:h-5 text-gray-300 dark:text-gray-600 group-hover:text-primary dark:group-hover:text-primary-light group-hover:translate-x-0.5 transition-all" />
                </td>
              )}
            </tr>
          ))}
          {totalRow && (
            <tr
              className={`font-semibold bg-gray-50 dark:bg-gray-700/50 ${
                onRowClick ? 'cursor-pointer hover:bg-primary/10 dark:hover:bg-primary/20 transition-all group' : ''
              }`}
              onClick={onRowClick ? () => handleRowClick(totalRow) : undefined}
              role={onRowClick ? 'button' : undefined}
              tabIndex={onRowClick ? 0 : undefined}
              onKeyDown={onRowClick ? (e) => e.key === 'Enter' && handleRowClick(totalRow) : undefined}
            >
              <td className={`py-1.5 qhd:py-2 4k:py-2.5 text-gray-900 dark:text-white ${onRowClick ? 'group-hover:text-primary dark:group-hover:text-primary-light' : ''}`}>Total</td>
              <td className={`py-1.5 qhd:py-2 4k:py-2.5 text-right ${totalRow.net < 0 ? 'text-green-600 dark:text-green-400' : ''}`}>
                {totalRow.netDisplay || formatCurrency(totalRow.net)}
              </td>
              <td className={`py-1.5 qhd:py-2 4k:py-2.5 text-right ${totalRow.misc < 0 ? 'text-green-600 dark:text-green-400' : ''}`}>
                {totalRow.miscDisplay || formatCurrency(totalRow.misc)}
              </td>
              <td className={`py-1.5 qhd:py-2 4k:py-2.5 text-right ${totalRow.buf < 0 ? 'text-green-600 dark:text-green-400' : ''}`}>
                {totalRow.bufDisplay || formatCurrency(totalRow.buf)}
              </td>
              {onRowClick && (
                <td className="py-1.5 qhd:py-2 4k:py-2.5 w-4 qhd:w-5 4k:w-6">
                  <ChevronRightIcon className="w-3.5 h-3.5 qhd:w-4 qhd:h-4 4k:w-5 4k:h-5 text-gray-300 dark:text-gray-600 group-hover:text-primary dark:group-hover:text-primary-light group-hover:translate-x-0.5 transition-all" />
                </td>
              )}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AccountsReceivableTable;
